module.exports = "/_next/static/images/bitcoin_b2-d9d6a4ab09bd6001c294f749e74df601.png";